<template>
  <button
    class="list-button"
    :class="variant == 'gray' ? 'button-gray' : 'button-primary'"
  >
    <i
      class="fa fa-list list-icon"
      :class="variant == 'gray' ? 'icon-gray' : 'icon-primary'"
    ></i>
  </button>
</template>

<script>
export default {
  props: ["variant"],
  data() {
    return {};
  },
};
</script>

<style>
.list-icon {
  font-size: 24px !important;
  cursor: pointer;
  transition: all 0.2s;
}

.icon-gray {
  color: rgb(116, 120, 141) !important;
}
.icon-primary {
  color: rgb(86, 100, 210) !important;
}
.list-button {
  background-color: inherit;
  border-radius: 10px;
  padding: 10px;
  border: 0px;
  transition: all 0.2s;
}
.list-button:hover .list-icon {
  transform: scale(1.3);
}
.button-gray:hover {
  background-color: rgba(116, 120, 141, 0.1);
}
.button-primary:hover {
  background-color: rgba(86, 100, 210, 0.1) !important;
}
</style>
